export const SELECT_RECOMMENDATION = 'SELECT_RECOMMENDATION'
export const SETTINGS_RECOMMENDATION = 'SETTINGS_RECOMMENDATION'

export const RECOMMENDATION_SETTINGS_STEPS = [SETTINGS_RECOMMENDATION, SELECT_RECOMMENDATION]

export const CARD_COLORS = [
  '#5372E2',
  '#04CB54',
  '#04A7CB',
  '#8A94F1',
  '#EB8F26',
  '#EB5147',
  '#F7BE51',
  '#E2538F',
  '#31D1E7',
  '#35C27E',
];
